import { Injectable } from '@angular/core';
import { CookieStorage } from '@kimaya/ngx-cookie-storage';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  get selectedLanguage(): string {
    return this._selectedLanguage;
  }

  set selectedLanguage(value: string) {
    this._selectedLanguage = value;
  }

  private _selectedLanguage: string;

  constructor(private cookieStorage: CookieStorage, private translateService: TranslateService) {
  }

  private _languageList: any[];

  get languageList(): any[] {
    return this._languageList;
  }

  set languageList(value: any[]) {
    this._languageList = value;
  }

  private _defaultLanguage: string;

  get defaultLanguage(): string {
    return this._defaultLanguage;
  }

  set defaultLanguage(value: string) {
    this._defaultLanguage = value;
    this.translateService.setDefaultLang(this._defaultLanguage);
  }

  private _languages: string[];

  get languages(): string[] {
    return this._languages;
  }

  set languages(value: string[]) {
    this._languages = value;
  }
}
